import { render, staticRenderFns } from "./IssuetrackingIndex.vue?vue&type=template&id=67d1e914&scoped=true"
import script from "./IssuetrackingIndex.vue?vue&type=script&lang=js"
export * from "./IssuetrackingIndex.vue?vue&type=script&lang=js"
import style0 from "./IssuetrackingIndex.vue?vue&type=style&index=0&id=67d1e914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d1e914",
  null
  
)

export default component.exports